import { render, staticRenderFns } from "./StudyRecordGradesSlidebar.vue?vue&type=template&id=363e82ba"
import script from "./StudyRecordGradesSlidebar.vue?vue&type=script&lang=js"
export * from "./StudyRecordGradesSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports